'use client';

import Link from 'next/link';

export default function CCPALink() {
  return (
    <Link
      href="/privacy#do-not-sell"
      className="text-sm text-teal-300 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-teal-400 rounded"
    >
      Do Not Sell My Personal Information
    </Link>
  );
}
